import { deserializeRange } from './textOffset';

export function clearSearchHighlightOverlay(overlay: HTMLElement | null): void {
    if (overlay) overlay.innerHTML = '';
}

export function paintSearchHighlightOverlay(
    textContainer: HTMLElement,
    overlay: HTMLElement,
    ranges: Array<{ startOffset: number; endOffset: number; active?: boolean }>,
): void {
    overlay.innerHTML = '';
    if (ranges.length === 0) return;

    const base = textContainer.getBoundingClientRect();

    for (const spec of ranges) {
        const range = deserializeRange(textContainer, spec.startOffset, spec.endOffset);
        if (!range) continue;

        const rects = range.getClientRects();
        for (let i = 0; i < rects.length; i++) {
            const rect = rects[i];
            const div = document.createElement('div');
            div.dataset.searchHighlight = spec.active ? 'active' : '1';
            div.style.position = 'absolute';
            div.style.left = `${rect.left - base.left}px`;
            div.style.top = `${rect.top - base.top}px`;
            div.style.width = `${rect.width}px`;
            div.style.height = `${rect.height}px`;
            div.style.background = spec.active ? 'rgba(255, 196, 0, 0.55)' : 'rgba(255, 235, 59, 0.38)';
            div.style.borderRadius = '2px';
            div.style.pointerEvents = 'none';
            div.style.zIndex = spec.active ? '5' : '4';
            overlay.appendChild(div);
        }
    }
}

export function scrollRangeIntoScrollContainer(
    scrollEl: HTMLElement | null,
    textContainer: HTMLElement,
    startOffset: number,
    endOffset: number,
): void {
    const range = deserializeRange(textContainer, startOffset, endOffset);
    if (!range) return;

    const rect = range.getBoundingClientRect();
    if (!scrollEl) {
        range.startContainer.parentElement?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
    }

    const c = scrollEl.getBoundingClientRect();
    const top = scrollEl.scrollTop + (rect.top - c.top) - Math.max(40, c.height * 0.25);
    scrollEl.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
}
